module.exports = __webpack_public_path__ + "img/carousel-servicios-5.4608b5b9.jpg";